module.exports = __webpack_public_path__ + "static/media/vtex22.97b48a11.png";